var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectAccIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7531_86934)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 2.00033C2.29783 2.00033 1.99935 2.2988 1.99935 2.66699V5.33366C1.99935 5.70185 2.29783 6.00033 2.66602 6.00033H13.3327C13.7009 6.00033 13.9993 5.70185 13.9993 5.33366V2.66699C13.9993 2.2988 13.7009 2.00033 13.3327 2.00033H2.66602ZM0.666016 2.66699C0.666016 1.56242 1.56145 0.666992 2.66602 0.666992H13.3327C14.4373 0.666992 15.3327 1.56242 15.3327 2.66699V5.33366C15.3327 6.43823 14.4373 7.33366 13.3327 7.33366H2.66602C1.56145 7.33366 0.666016 6.43823 0.666016 5.33366V2.66699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66602 10.0003C2.29783 10.0003 1.99935 10.2988 1.99935 10.667V13.3337C1.99935 13.7018 2.29783 14.0003 2.66602 14.0003H13.3327C13.7009 14.0003 13.9993 13.7018 13.9993 13.3337V10.667C13.9993 10.2988 13.7009 10.0003 13.3327 10.0003H2.66602ZM0.666016 10.667C0.666016 9.56242 1.56145 8.66699 2.66602 8.66699H13.3327C14.4373 8.66699 15.3327 9.56242 15.3327 10.667V13.3337C15.3327 14.4382 14.4373 15.3337 13.3327 15.3337H2.66602C1.56145 15.3337 0.666016 14.4382 0.666016 13.3337V10.667Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAccIcon);
export default __webpack_public_path__ + "static/media/select-acc-icon.6b0f4f2fa759cd7bdb5116173eb9e49e.svg";
export { ForwardRef as ReactComponent };